module.exports = __webpack_public_path__ + "static/gazereplay-40f6c3d3cba04a057fc280a3b521ee9f.gif";